module.exports = __webpack_public_path__ + "static/iphone-mock-edef77c1179f5cdfbbfe16db134beed1.png";